import React, {useState} from "react";
// import { useNavigate } from "react-router-dom";

function HeaderDashMain() {
  // const navigate = useNavigate();
  const handleLogout = () => {
    // Clear user-related data from localStorage
    localStorage.clear();

    // Navigate to the login page or another appropriate page
    // navigate("/");
  };

  const [authenticated, setAuthenticated] = useState(
    JSON.parse(localStorage.getItem("userdata"))
  );
  return (
    <div>
      <header className="header-area header-style-1 header-height-2 pt-3 ">
        {/* <div className="header-middle header-middle-ptb-1 d-none d-lg-block"> */}
          <div className="container">
            <div className="header-wrap">
              <div className="logo logo-width-1">
                <a href="/">
                  <img
                    src="storage/general/ks-logo32.png"
                    alt="Kerala Specials-Logo"
                  />
                </a>
              </div>
              <div className="header-right">
                <div className="search-style-2">
                  {/* <form
                    // action="https://nest.botble.com/products"
                    className="form--quick-search"
                    // data-ajax-url="https://nest.botble.com/ajax/search-products"
                    // method="GET"
                  >
                    <input
                      type="text"
                      className="input-search-product"
                      placeholder="Search for items..."
                      //   value=""
                      autocomplete="off"
                    />
                    <div className="panel--search-result"></div>
                  </form> */}
                </div>
                
                <div className="header-action-right">
                
                  <div className="header-action-2">
                    <div className="header-action-icon-2">
                      <a href="/login">
                        <div className="d-flex justify-content-between hovermain hover-up">
                      <h6 className="mt-1 px-1">{authenticated.admin_name}</h6>
                        <img
                          className="svgInject rounded-circle"
                          alt="Account"
                          src="themes/nest/imgs/theme/icons/icon-user.svg"
                        /></div>
                      </a>
                      <a href="/">
                        <span className="lable me-1"></span>
                      </a>
                      <div className="cart-dropdown-wrap cart-dropdown-hm2 account-dropdown">
                        <ul>
                          <li>
                            <a href="" onClick={handleLogout}>
                             <h6> <i className="fi fi-rs-user-delete mr-10"></i>
                              Logout</h6>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        {/* </div> */}
      </header>

      {/* ---- */}
      <div className="mobile-header-active mobile-header-wrapper-style">
        <div className="mobile-header-wrapper-inner">
          <div className="mobile-header-top">
            <div className="mobile-header-logo">
              <a href="index.html">
                <img
                  src="storage/general/logo.png"
                  alt="Nest - Laravel Multipurpose eCommerce Script"
                />
              </a>
            </div>
            <div className="mobile-menu-close close-style-wrap close-style-position-inherit">
              <button className="close-style search-close">
                <i className="icon-top"></i>
                <i className="icon-bottom"></i>
              </button>
            </div>
          </div>
          <div className="mobile-header-content-area">
            <div className="mobile-search search-style-3 mobile-header-border">
              <form
                action="https://nest.botble.com/products"
                className="form--quick-search"
                data-ajax-url="https://nest.botble.com/ajax/search-products"
              >
                <input
                  type="text"
                  name="q"
                  className="input-search-product"
                  placeholder="Search for items..."
                  value=""
                  autocomplete="off"
                />
                <button type="submit">
                  <i className="fi-rs-search"></i>
                </button>
                <div className="panel--search-result"></div>
              </form>
            </div>
            <div className="mobile-menu-wrap mobile-header-border">
              <nav>
                <ul className="mobile-menu">
                  <li className=" menu-item-has-children ">
                    <span className="menu-expand"></span>
                    <a href="index.html" target="_self">
                      <i className="fi-rs-home"></i> Home{" "}
                    </a>
                    <ul className="dropdown">
                      <li className=" ">
                        <a href="index.html" target="_self">
                          {" "}
                          Home 1{" "}
                        </a>
                      </li>
                      <li className=" ">
                        <a href="homepage-2.html" target="_self">
                          {" "}
                          Home 2{" "}
                        </a>
                      </li>
                      <li className=" ">
                        <a href="homepage-3.html" target="_self">
                          {" "}
                          Home 3{" "}
                        </a>
                      </li>
                      <li className=" ">
                        <a href="homepage-4.html" target="_self">
                          {" "}
                          Home 4{" "}
                        </a>
                      </li>
                      <li className=" ">
                        <a href="homepage-5.html" target="_self">
                          {" "}
                          Home 5{" "}
                        </a>
                      </li>
                      <li className=" ">
                        <a href="homepage-6.html" target="_self">
                          {" "}
                          Home 6{" "}
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li className=" menu-item-has-children ">
                    <span className="menu-expand"></span>
                    <a href="products.html" target="_self">
                      {" "}
                      Shop{" "}
                    </a>
                    <ul className="dropdown">
                      <li className=" ">
                        <a href="products.html" target="_self">
                          {" "}
                          Shop Grid - Full Width{" "}
                        </a>
                      </li>
                      <li className=" ">
                        <a
                          href="productsb358.html?layout=product-right-sidebar"
                          target="_self"
                        >
                          {" "}
                          Shop Grid - Right Sidebar{" "}
                        </a>
                      </li>
                      <li className=" ">
                        <a
                          href="products380e.html?layout=product-left-sidebar"
                          target="_self"
                        >
                          {" "}
                          Shop Grid - Left Sidebar{" "}
                        </a>
                      </li>
                      <li className=" ">
                        <a
                          href="product-categories/milks-and-dairies.html"
                          target="_self"
                        >
                          Products Of Category{" "}
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li className=" menu-item-has-children ">
                    <span className="menu-expand"></span>
                    <a href="stores.html" target="_self">
                      {" "}
                      Stores{" "}
                    </a>
                    <ul className="dropdown">
                      <li className=" ">
                        <a href="stores.html" target="_self">
                          {" "}
                          Stores - Grid{" "}
                        </a>
                      </li>
                      <li className=" ">
                        <a
                          href="stores9f16.html?layout=stores-list"
                          target="_self"
                        >
                          {" "}
                          Stores - List{" "}
                        </a>
                      </li>
                      <li className=" ">
                        <a href="stores/gopro.html" target="_self">
                          {" "}
                          Store - Detail{" "}
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li className=" menu-item-has-children ">
                    <span className="menu-expand"></span>
                    <a
                      href="products/seeds-of-change-organic-quinoe-digital.html"
                      target="_self"
                    >
                      {" "}
                      Product
                    </a>
                    <ul className="dropdown">
                      <li className=" ">
                        <a
                          href="products/seeds-of-change-organic-quinoe-digital.html"
                          target="_self"
                        >
                          {" "}
                          Product Right Sidebar{" "}
                        </a>
                      </li>
                      <li className=" ">
                        <a
                          href="products/all-natural-italian-style-chicken-meatballs.html"
                          target="_self"
                        >
                          {" "}
                          Product Left Sidebar{" "}
                        </a>
                      </li>
                      <li className=" ">
                        <a
                          href="products/angies-boomchickapop-sweet-salty-kettle-corn.html"
                          target="_self"
                        >
                          {" "}
                          Product Full Width{" "}
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li className=" menu-item-has-children ">
                    <span className="menu-expand"></span>
                    <a href="blog.html" target="_self">
                      {" "}
                      Blog{" "}
                    </a>
                    <ul className="dropdown">
                      <li className=" ">
                        <a href="blog.html" target="_self">
                          {" "}
                          Blog Grid{" "}
                        </a>
                      </li>
                      <li className=" ">
                        <a href="blog-list.html" target="_self">
                          {" "}
                          Blog List{" "}
                        </a>
                      </li>
                      <li className=" ">
                        <a href="blog-big.html" target="_self">
                          {" "}
                          Blog Big{" "}
                        </a>
                      </li>
                      <li className=" ">
                        <a href="blog-wide.html" target="_self">
                          {" "}
                          Blog Wide{" "}
                        </a>
                      </li>
                      <li className=" menu-item-has-children ">
                        <span className="menu-expand"></span>
                        <a
                          href="blog/4-expert-tips-on-how-to-choose-the-right-mens-wallet.html"
                          target="_self"
                        >
                          {" "}
                          Single Post{" "}
                        </a>
                        <ul className="dropdown">
                          <li className=" ">
                            <a
                              href="blog/4-expert-tips-on-how-to-choose-the-right-mens-wallet.html"
                              target="_self"
                            >
                              {" "}
                              Single Post Right Sidebar{" "}
                            </a>
                          </li>
                          <li className=" ">
                            <a
                              href="blog/sexy-clutches-how-to-buy-wear-a-designer-clutch-bag.html"
                              target="_self"
                            >
                              {" "}
                              Single Post Left Sidebar{" "}
                            </a>
                          </li>
                          <li className=" ">
                            <a
                              href="blog/the-top-2020-handbag-trends-to-know.html"
                              target="_self"
                            >
                              {" "}
                              Single Post Full Width{" "}
                            </a>
                          </li>
                          <li className=" ">
                            <a
                              href="blog/how-to-match-the-color-of-your-handbag-with-an-outfit.html"
                              target="_self"
                            >
                              {" "}
                              Single Post with Product Listing{" "}
                            </a>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                  <li className=" ">
                    <a href="faq.html" target="_self">
                      {" "}
                      FAQ{" "}
                    </a>
                  </li>
                  <li className=" ">
                    <a href="contact.html" target="_self">
                      {" "}
                      Contact Us{" "}
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
            <div className="mobile-header-info-wrap">
              <div className="single-mobile-header-info">
                <a className="mobile-language-active" href="#">
                  <i className="fi-rs-globe"></i> Language{" "}
                  <span>
                    <i className="fi-rs-angle-down"></i>
                  </span>
                </a>
                <div className="lang-curr-dropdown lang-dropdown-active">
                  <ul>
                    <li>
                      <a rel="alternate" hreflang="en" href="register.html">
                        <img
                          src="vendor/core/core/base/images/flags/us.svg"
                          title="English"
                          width={16}
                          alt="English"
                        />{" "}
                        English
                      </a>
                    </li>
                    <li>
                      <a rel="alternate" hreflang="vi" href="vi/register.html">
                        <img
                          src="vendor/core/core/base/images/flags/vn.svg"
                          title="Tiếng Việt"
                          width={16}
                          alt="Tiếng Việt"
                        />{" "}
                        Tiếng Việt
                      </a>
                    </li>
                    <li>
                      <a rel="alternate" hreflang="ar" href="ar/register.html">
                        <img
                          src="vendor/core/core/base/images/flags/sa.svg"
                          title="Arabic"
                          width={16}
                          alt="Arabic"
                        />{" "}
                        Arabic
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="single-mobile-header-info">
                <a className="mobile-language-active" href="#">
                  <i className="fi-rs-money"></i> Currency{" "}
                  <span>
                    <i className="fi-rs-angle-down"></i>
                  </span>
                </a>
                <div className="lang-curr-dropdown lang-dropdown-active">
                  <ul>
                    <li>
                      <a href="register.html">USD</a>
                    </li>
                    <li>
                      <a href="register.html">EUR</a>
                    </li>
                    <li>
                      <a href="register.html">VND</a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="single-mobile-header-info">
                <a href="orders/tracking.html">
                  <i className="fi-rs-shopping-cart"></i> Order tracking
                </a>
              </div>
              <div className="single-mobile-header-info">
                <a href="compare.html">
                  <i className="fi-rs-refresh"></i>
                  Compare
                </a>
              </div>
              <div className="single-mobile-header-info">
                <a href="/login">
                  <i className="fi-rs-user"></i> Log In / Sign Up
                </a>
              </div>
              <div className="single-mobile-header-info">
                <a href="tel:1900 - 888">
                  <i className="fi-rs-headphones"></i>
                  1900 - 888
                </a>
              </div>
            </div>
            <div className="mobile-social-icon mb-50">
              <p className="mb-15 font-heading h6 me-2">Follow Us</p>
              <a href="https://www.facebook.com/" title="Facebook">
                <img src="storage/general/facebook.png" alt="Facebook" />
              </a>
              <a href="https://www.twitter.com/" title="Twitter">
                <img src="storage/general/twitter.png" alt="Twitter" />
              </a>
              <a href="https://www.instagram.com/" title="Instagram">
                <img src="storage/general/instagram.png" alt="Instagram" />
              </a>
              <a href="https://www.pinterest.com/" title="Pinterest">
                <img src="storage/general/pinterest.png" alt="Pinterest" />
              </a>
              <a href="https://www.youtube.com/" title="Youtube">
                <img src="storage/general/youtube.png" alt="Youtube" />
              </a>
            </div>
            <div className="site-copyright">
              Copyright © 2023 Nest all rights reserved. Powered by Botble.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HeaderDashMain;
